<template>
    <div id="question">
        <Header v-if="self.image !== undefined" :image="updateImage" :progress_questions="questions" />
        <section>
        <h2>{{ self.question }}</h2>
        <ol v-if="!showExplanation" class="answers" :type="settings.list_type">
            <li v-for="(answer,index) in shuffleAnswers" v-bind:key="index" v-html="answer" @click="check"></li>
        </ol>
        <Explanation v-if="showExplanation" :button_colors="settings.button_colors" :button="settings.skip_explanation" :content="self.explanation" @next="updateNext" />
        </section>
    </div>
</template>

<script>
import Explanation from './Explanation.vue'
import Header from './Header.vue'

export default {
  name: 'Question',
  components: {
      Explanation,
      Header
  },
  props:['self','settings','index','correct','questions'],
  data: function(){
      return{
          answers: [],
          explanatory: this.explanation,
          displayExplanation: false,
          correctAnswer: false,
          gameOver: false,
          active: true
      }
  },
  methods: {
    update(){
        this.$emit(this.action)
    },
    updateNext(){
        this.displayExplanation = false;
        this.endRound('next',this.correctAnswer,this.gameOver);
    },
    check(target){
        var over = true;
        if(this.active){
            if(this.index < (this.settings.rounds - 1) ) over = false;
            this.gameOver = over;
            if(this.correct.includes(target.srcElement.innerHTML)){
                this.correctAnswer = true;
                target.srcElement.classList.add('correct');
            }
            else{
                this.correctAnswer = false;
                target.srcElement.classList.add('false');
            }
            this.deactivateLi();
            this.explain(target);
        }
    },
    explain(target){
        setTimeout( ()=> {
            if(this.ifExplanation)this.displayExplanation = true;
            else this.endRound('next',this.correctAnswer,this.gameOver);
            this.resetLi(target);
        }, 420 )
        
    },
    endRound(update,correct_answer,game_over){
        this.$emit(update,correct_answer,game_over);
    },
    deactivateLi(){
        this.active = false;
    },
    resetLi(target){
        target.srcElement.classList.remove('correct');
        target.srcElement.classList.remove('false');
        this.active = true;
    },
    shuffle(array){
      var ctr = array.length, temp, index;
      while (ctr > 0) {
        index = Math.floor(Math.random() * ctr);
        ctr--;
        temp = array[ctr];
        array[ctr] = array[index];
        array[index] = temp;
      }
      return array;
    }
  },
  computed: {
    ifExplanation(){
        if(this.self.explanation.text == null || this.self.explanation.text == "" || this.self.explanation == null){
            return false;
        }
        else{
            return true;
        }
    },
    showExplanation(){
        return this.displayExplanation;
    },
    updateImage(){
          return this.self.image
    },
    shuffleAnswers(){
        return this.shuffle(this.self.answers)
    }
  }
}
</script>
